import api from "@/utils/axios";
import { appendFirmFilterParams } from "@/lib/firmFilters";

const getApiBase = () => process.env.NEXT_PUBLIC_API_BASE_URL || "/api/v1";

export const fetchFirms = async (
  page = 1,
  limit = 10,
  filter = "ratings",
  search = "",
  advancedFilters = null,
) => {
  const baseUrl = getApiBase();
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    filter,
  });

  if (search) {
    params.set("search", search);
  }

  appendFirmFilterParams(params, advancedFilters);

  const url = `${baseUrl}/prop-firms?${params.toString()}`;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch firms: ${res.status} ${res.statusText}`);
  }

  return res.json();
};

export const fetchFirmFilterOptions = async () => {
  const baseUrl = getApiBase();
  const url = `${baseUrl}/prop-firms/filters`;

  const res = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  if (!res.ok) {
    throw new Error(
      `Failed to fetch firm filter options: ${res.status} ${res.statusText}`,
    );
  }

  return res.json();
};

export const fetchFeaturedFirms = async () => {
  const baseUrl = getApiBase();
  const url = `${baseUrl}/prop-firms/featured/top`;

  const res = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    cache: "no-store",
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch featured firms: ${res.status} ${res.statusText}`);
  }

  return res.json();
};

export const fetchFirmById = async (id) => {
  const baseUrl = getApiBase();
  const url = `${baseUrl}/prop-firms/${id}`;

  const res = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    cache: "no-store", // ensures fresh data
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch firm with ID ${id}: ${res.status} ${res.statusText}`);
  }

  return res.json();
};

export const searchFirms = async (query) => {
  const res = await api.get(`/prop-firms/search?q=${query}`);
  return res.data;
};
